<script setup lang="ts">
import type { Color } from "@asap/design/styles/colors";

type Props = {
  isOpen: boolean;
  title?: string;
  titleIcon?: string | null;
  description?: string;
  primaryLabel?: string;
  primaryColor?: Color;
  secondaryLabel?: string;
  isConfirming?: boolean;
};

const props = withDefaults(defineProps<Props>(), {
  titleIcon: "i-ph-receipt-x-duotone",
  description: "",
  title: undefined,
  primaryLabel: undefined,
  primaryColor: "critical",
  secondaryLabel: undefined,
  isConfirming: false,
});
const emit = defineEmits<{
  "update:onConfirm": [];
  "update:open": [value: boolean];
}>();

const { t } = useI18n();
</script>

<template>
  <AwModal
    position="center"
    size="md"
    :open="isOpen"
    @update:open="emit('update:open', $event)"
    @close-prevent="emit('update:open', false)"
  >
    <template #header>
      <div class="flex flex-row items-center gap-2 text-secondary-900">
        <AwIcon v-if="titleIcon" :name="titleIcon" class="font-size-4" />
        <div class="text-md flex flex-row items-center gap-1 font-size-4">
          {{ props.title ?? t("common.confirmModal.title") }}
        </div>
      </div>
      <AwButton :icon="'i-ph-x-bold'" size="sm" color="secondary" variant="ghost" @click="emit('update:open', false)" />
    </template>
    <template #body>
      <div style="width: 97%; padding-left: 2.5%; margin-top: 20px; margin-bottom: 20px">
        <slot name="description">{{ description }}</slot>
      </div>
    </template>
    <template #footer>
      <div class="flex justify-end w-full gap-2">
        <AwButton
          color="secondary"
          variant="ghost"
          :label="props.secondaryLabel ?? t('common.actions.cancel')"
          @click="emit('update:open', false)"
        />
        <AwButton
          :label="props.primaryLabel ?? t('common.actions.confirm')"
          :color="primaryColor"
          :is-loading="isConfirming"
          :disabled="isConfirming"
          @click="emit('update:onConfirm')"
        />
      </div>
    </template>
  </AwModal>
</template>
